module.exports = __webpack_public_path__ + "images/district_back.1789440611829.png";